import React from "react";
import { useParams } from "react-router-dom";
import AllNflGamesHelper from "../../classes/allNflGamesHelper";
import useGetter from "../../hooks/queryResults/useGetter";
import useIsLoading from "../../hooks/queryResults/useIsLoading";
import useLeagueSeason from "../../hooks/queryResults/useLeagueSeason";
import useNflGamesForWeek from "../../hooks/queryResults/useNflGamesForWeek";
import useStandings from "../../hooks/queryResults/useStandings";
import useTeams from "../../hooks/queryResults/useTeams";
import useWeek from "../../hooks/queryResults/useWeek";
import TeamLogo from "../team/TeamLogo";
import Loading from "../ui/Loading";

export default function LeagueSeasonWaiversPriorityList() {
  const { league: leagueUrl, season: seasonUrl } = useParams();
  const { currentWeek } = useWeek();

  const { leagueSeason, leagueQuery } = useLeagueSeason();
  const { teams, teamsQuery } = useTeams();
  const { standingsData, standingsQuery } = useStandings(currentWeek);

  const season = leagueSeason?.obj.season;
  const { nflGamesData, nflGamesQuery } = useNflGamesForWeek(
    season,
    currentWeek
  );

  let allNflGamesHelper = null;
  let weekToShow = currentWeek;
  if (nflGamesData) {
    allNflGamesHelper = new AllNflGamesHelper(nflGamesData);
    const haveAllNflGamesEnded =
      allNflGamesHelper.haveAllNflGamesEnded(currentWeek);
    weekToShow += haveAllNflGamesEnded ? 1 : 0;
  }

  const enabled = !!nflGamesData;
  const { data: waiversPriorityListData, query: waiversPriorityListQuery } =
    useGetter(
      `/rosters/${leagueUrl}/${seasonUrl}/${weekToShow}/waivers/priority`,
      { enabled }
    );

  const isLoading = useIsLoading(
    waiversPriorityListData,
    waiversPriorityListQuery,
    teams,
    teamsQuery,
    leagueSeason,
    leagueQuery,
    nflGamesData,
    nflGamesQuery,
    standingsData,
    standingsQuery
  );
  if (isLoading) return <Loading />;

  return (
    <div>
      <h3>Waivers Priority List - Week {weekToShow}</h3>
      <table>
        <thead>
          <tr>
            <th>Num</th>
            <th colSpan={2}>Team</th>
            <th>W</th>
            <th>L</th>
            <th>T</th>
            <th>Pct.</th>
            <th>PFA</th>
            <th>PAA</th>
          </tr>
        </thead>
        <tbody>
          {waiversPriorityListData.waiversPriorityList.teams.map(
            (teamId, i) => {
              const team = teams.getTeamById(teamId);
              const st = standingsData.standings.filter(
                (st) => st.team === teamId
              )[0];

              return (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>
                    <TeamLogo team={team} size={"sm"} />
                  </td>
                  <td>{team.fullName}</td>
                  <td>{st.recordTotal.wins}</td>
                  <td>{st.recordTotal.losses}</td>
                  <td>{st.recordTotal.ties}</td>
                  <td>{st.recordTotal.pct.toFixed(3)}</td>
                  <td>{st.recordTotal.pointsForAvg.toFixed(1)}</td>
                  <td>{st.recordTotal.pointsAgainstAvg.toFixed(1)}</td>
                </tr>
              );
            }
          )}
        </tbody>
      </table>
    </div>
  );
}
